import { mutationTypes } from './mutations';
import api from './api'

export const actionTypes = {
    productsInit: 'productsInit',
    productsLoad: 'productsLoad',
    productsCreate: 'productsCreate',
	productsUpdate: 'productsUpdate',
	productsUpdatePositions: 'productsUpdatePositions',
	productsDelete: 'productsDelete',
	productsFilesLoad: 'productsFilesLoad',
	productsFilesCreate: 'productsFilesCreate',
	productsFilesUpdate: 'productsFilesUpdate',
	productsFilesDelete: 'productsFilesDelete',
    productsValidate: 'productsValidate',
	productsValidationClear: 'productsValidationClear',
	productsValidationModalClose: 'productsValidationModalClose',
	productsBrandsLoad: 'productsBrandsLoad',
	productsBrandsCreate: 'productsBrandsCreate',
	productsBrandsUpdate: 'productsBrandsUpdate',
	productsBrandsDelete: 'productsBrandsDelete',
}

export default {
	[actionTypes.productsInit]({ commit }) {
		if (localStorage.getItem(resource))
			commit(mutationTypes.PRODUCTS_ADD, JSON.parse(localStorage.getItem(resource)))
    },
    [actionTypes.productsLoad]({ commit }) {
        return api.productsLoad()
            .then(res => commit(mutationTypes.PRODUCTS_ADD, res.data.data))        
    },
    async [actionTypes.productsCreate]({ commit, dispatch }, product) {
		const result = await dispatch(actionTypes.productsValidate, product)
		if (result === true)
			return api.productsCreate(product)
				.then(res => commit(mutationTypes.PRODUCTS_CREATE, res.data))
				.catch(error => {
					commit(mutationTypes.PRODUCTS_VALIDATION_MODAL, true)
					commit(mutationTypes.PRODUCTS_VALIDATION_ERRORS, error.response.data.errors)
					return Promise.reject(error)
				})
		commit(mutationTypes.PRODUCTS_VALIDATION_MODAL, true)
		commit(mutationTypes.PRODUCTS_VALIDATION_ERRORS, result)
		return Promise.reject()
	},
	async [actionTypes.productsUpdate]({ commit, dispatch }, product) {
		const result = await dispatch(actionTypes.productsValidate, product)
		if (result === true)
			return api.productsUpdate(product)
				.then(res => commit(mutationTypes.PRODUCTS_UPDATE, res.data))
				.catch(error => {
					commit(mutationTypes.PRODUCTS_VALIDATION_MODAL, true)
					commit(mutationTypes.PRODUCTS_VALIDATION_ERRORS, error.response.data.errors)
					return Promise.reject(error)
				})
		commit(mutationTypes.PRODUCTS_VALIDATION_MODAL, true)
		commit(mutationTypes.PRODUCTS_VALIDATION_ERRORS, result)
		return Promise.reject()
	},
	[actionTypes.productsUpdatePositions]({ commit, dispatch }, positions) {
		return api.productsUpdatePositions(positions)
				.then(res => commit(mutationTypes.PRODUCTS_UPDATE_POSITIONS, positions))		
	},
	[actionTypes.productsFilesLoad]({ commit }) {
		return api.productsFilesLoad()
			.then(res => commit(mutationTypes.PRODUCTS_FILES_LOAD, res.data.data))		
	},


	[actionTypes.productsFilesCreate]({ commit }, productFile) {		
		api.productsFilesCreate(productFile)
			.then(res => commit(mutationTypes.PRODUCTS_FILES_CREATE, res.data))
	},	
	[actionTypes.productsFilesUpdate]({ commit }, productFile) {		
		api.productsFilesUpdate(productFile)
			.then(data => commit(mutationTypes.PRODUCTS_FILES_UPDATE, data))
	},	
	[actionTypes.productsFilesDelete]({ commit }, productFile) {		
		api.productsFilesDelete(productFile)
			.then(data => commit(mutationTypes.PRODUCTS_FILES_DELETE, productFile))
	},
    [actionTypes.productsValidate]({ commit }, product) {
		let result = {}
    
        if (product.title.length < 4 || product.title.length > 255)
			result['title'] = 'The title is needed and should be between 4 and 255 letters long'
		if (product.slug.length < 2 || product.slug.length > 50)
			result['slug'] = 'The slug is needed and should be between 2 and 50 letters long'
		if (product.description.length < 8)
			result['description'] = 'The product description cannot be empty'	
                
		if (Object.keys(result).length == 0) {
			commit(mutationTypes.PRODUCTS_VALIDATION_CLEAR, result)
			return true
		}
		else {
			commit(mutationTypes.PRODUCTS_VALIDATION_ERRORS, result)
			return result
		}
	},
	[actionTypes.productsValidationClear]({ commit }) {
		commit(mutationTypes.PRODUCTS_VALIDATION_CLEAR)	
	},
	[actionTypes.productsValidationModalClose]({ commit }) {
		commit(mutationTypes.PRODUCTS_VALIDATION_MODAL, false)		
    },
    [actionTypes.productsDelete]({state, commit}, product) {
        api.productsDelete(product)
            .then(data => commit(mutationTypes.PRODUCTS_DELETE, product))
	},
	[actionTypes.productsBrandsLoad]({ commit }) {
		return api.productsBrandsLoad()
			.then(res => commit(mutationTypes.PRODUCTS_BRANDS_LOAD, res.data.data))		
	},
	[actionTypes.productsBrandsCreate]({ commit }, brand) {		
		api.productsBrandsCreate(brand)
			.then(res => commit(mutationTypes.PRODUCTS_BRANDS_CREATE, res.data))
	},
	[actionTypes.productsBrandsUpdate]({ commit }, brand) {		
		api.productsBrandsUpdate(brand)
			.then(res => commit(mutationTypes.PRODUCTS_BRANDS_UPDATE, res.data))
	},	
	[actionTypes.productsBrandsDelete]({ commit }, brand) {		
		api.productsBrandsDelete(brand)
			.then(() => commit(mutationTypes.PRODUCTS_BRANDS_DELETE, brand))
	}
}
